import 'bootstrap';

import '../../components/navi-bootstrap-offcanvas/navi-bootstrap-offcanvas';
import '../../components/preloader/preloader';
import '../../components/navi-bootstrap-offcanvas/navi-bootstrap-offcanvas';
import '../../font-service/font-service';
import '../../components/smooth-scrolling/smooth-scrolling.js';



import {
    detectMobile,
    isIE
} from '../../components/browser-detection/browser-detection.js';
// import 'objectFitPolyfill/dist/objectFitPolyfill.basic.min';
// Global Styles

import './scss/page-meta.scss';

// switch links to home url

const $navlinks = [...document.querySelectorAll('#menu-main a')]


$(window).on('load', () => {
    console.log(window.homeUrl)
    $navlinks.forEach((link) => {
        const originLink = link.getAttribute('href')
        const completeLink = window.homeUrl + "/" + originLink;
        link.setAttribute('href', completeLink);
    })
})